[
  {
    "dia": 15,
    "mupi": 2,
    "hora": "10h45min",
    "numero": 28,
    "titulo": "Caracterização de sistemas de matrizes para a realização de restaurações Classe II",
    "autor": "Beatriz Pimparel"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "10h52min",
    "numero": 29,
    "titulo": "Ativação dos sistemas de Irrigação em Endodontia: revisão narrativa",
    "autor": "Mariana Cunha"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "10h59min",
    "numero": 30,
    "titulo": "Cimentos Biocerâmicos: Invovação no Tratamento Endodôntico e Promoção da Regeneração Pulpar",
    "autor": "Carlota Ávila"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "11h06min",
    "numero": 31,
    "titulo": "Nanotecnologia em Endodontia: O Papel das Nanopartículas no Tratamento Endodôntico",
    "autor": "Djeinifa Spencer"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "11h13min",
    "numero": 32,
    "titulo": "Avaliação dos Cimentos de Obturação - Revisão Narrativa",
    "autor": "Tiago Nóbrega"
  }
]